export default "__VITE_ASSET__Kzjtzxtr__"